export const ApprovalStatusConst = {
  UNAPPROVED: 0, //未承認
  APPROVED: 1,　　//承認（成立）
  DISAPPROVAL: 2,　　//承認（不成立）
} as const;

export type ApprovalStatusType = typeof ApprovalStatusConst[keyof typeof ApprovalStatusConst];